/**
 * Main JavaScript file
 * General functionality for Telemedico theme
 */

(function() {
    'use strict';

    // Wait for DOM to be ready
    document.addEventListener('DOMContentLoaded', function() {

        // Smooth scroll for anchor links
        const anchorLinks = document.querySelectorAll('a[href^="#"]');

        anchorLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                const href = this.getAttribute('href');

                if (href !== '#' && href !== '#0') {
                    const target = document.querySelector(href);

                    if (target) {
                        e.preventDefault();

                        target.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    }
                }
            });
        });

        // Add active class to current menu item
        const currentLocation = window.location.href;
        const menuItems = document.querySelectorAll('.nav-menu a');

        menuItems.forEach(function(item) {
            if (item.href === currentLocation) {
                item.parentElement.classList.add('current-menu-item');
            }
        });

        // Back to top button (if you want to add one later)
        const backToTop = document.querySelector('.back-to-top');

        if (backToTop) {
            window.addEventListener('scroll', function() {
                if (window.pageYOffset > 300) {
                    backToTop.classList.add('visible');
                } else {
                    backToTop.classList.remove('visible');
                }
            });

            backToTop.addEventListener('click', function(e) {
                e.preventDefault();
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }

        // External links - open in new tab
        const externalLinks = document.querySelectorAll('a[href^="http"]');
        const currentDomain = window.location.hostname;

        externalLinks.forEach(function(link) {
            const linkDomain = new URL(link.href).hostname;

            if (linkDomain !== currentDomain) {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            }
        });

        // Add loading class to images
        const images = document.querySelectorAll('img');

        images.forEach(function(img) {
            if (img.complete) {
                img.classList.add('loaded');
            } else {
                img.addEventListener('load', function() {
                    this.classList.add('loaded');
                });
            }
        });

    });

})();

